import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { IconButton, Close } from '@tds/core-interactive-icon';
import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';

import {
  Backdrop,
  ModalMain,
  ModalInner,
  ModalMessageMain,
  ModalCancel,
  ModalHeading
} from './css';

import OrderHeader from './components/orderHeader';
import OrderSummary from './components/summary';
import OrderAttachments from './components/orderAttachements';
import OrderHistory from './components/orderHistory';
import OrderComments from './components/orderComments';
import OrderActions from './components/orderActions';

const ViewOrderDetails = ({
  orderData,
  userRights,
  closeViewDetails,
  fetchOrders
}) => {
  const { canPerformAction } = userRights;

  return (
    <Backdrop>
      <ModalMain>
        <ModalInner>
          <ModalMessageMain>
            <ModalHeading>
              <Heading level="h2">
                Order Details - {_.get(orderData, 'orderId', '')}
              </Heading>
            </ModalHeading>
            <DimpleDivider />
            <OrderHeader orderData={orderData} userRights={userRights} />
            <DimpleDivider />
            <OrderSummary orderData={orderData} />
            <DimpleDivider />
            <OrderAttachments orderData={orderData} />
            <DimpleDivider />
            <OrderHistory orderData={orderData} />
            <DimpleDivider />
            <OrderComments orderData={orderData} userRights={userRights} />
            <DimpleDivider />
            {canPerformAction && (
              <OrderActions orderData={orderData} fetchOrders={fetchOrders} />
            )}
          </ModalMessageMain>
          <ModalCancel>
            <IconButton
              icon={Close}
              onClick={() => {
                closeViewDetails(false);
                fetchOrders();
              }}
              a11yText="Close"
            />
          </ModalCancel>
        </ModalInner>
      </ModalMain>
    </Backdrop>
  );
};

ViewOrderDetails.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  userRights: PropTypes.objectOf(PropTypes.object).isRequired,
  closeViewDetails: PropTypes.func.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default ViewOrderDetails;
